import React, { useMemo, useState } from "react";
import { Link } from "react-router-dom";
const proCard1 = "https://d1vqw4it8x9uac.cloudfront.net/admin/profilecards-6-1790236892.png";
const proCard2 = "https://d1vqw4it8x9uac.cloudfront.net/admin/profilecards-7-1790236892.png";
const proCard3 = "https://d1vqw4it8x9uac.cloudfront.net/admin/profilecards-8-1790236892.png";
const idea1 = "https://d1vqw4it8x9uac.cloudfront.net/admin/uploads-7-1790236892.png";
const idea2 = "https://d1vqw4it8x9uac.cloudfront.net/admin/uploads-8-1790236892.png";
const idea3 = "https://d1vqw4it8x9uac.cloudfront.net/admin/uploads-9-1790236892.png";
const idea4 = "https://d1vqw4it8x9uac.cloudfront.net/admin/uploads-10-1790236892.png";
const idea5 = "https://d1vqw4it8x9uac.cloudfront.net/admin/uploads-11-1790236892.png";
const product1 = "https://d1vqw4it8x9uac.cloudfront.net/admin/uploads-16-1790236892.png";
const product2 = "https://d1vqw4it8x9uac.cloudfront.net/admin/uploads-13-1790236892.png";
const product3 = "https://d1vqw4it8x9uac.cloudfront.net/admin/uploads-18-1790236892.png";
const product4 = "https://d1vqw4it8x9uac.cloudfront.net/admin/uploads-12-1790236892.png";
const product5 = "https://d1vqw4it8x9uac.cloudfront.net/admin/uploads-19-1790236892.png";

const FILTERS = ["Professionals", "Inspiration", "Products"];

// Ideas and products are currently mocked via provided UI strips (static assets).

function RevampExploreFeed() {
  const [active, setActive] = useState(FILTERS[0]);

  const visible = useMemo(() => {
    return {
      pros: active === "Professionals" || active === "All",
      ideas: active === "Inspiration" || active === "All",
      products: active === "Products" || active === "All",
    };
  }, [active]);

  return (
    <section className="revamp-feed-wrap" aria-label="Explore feed">
      <div className="revamp-feed-inner">
        <div className="revamp-feed-head">
          <div className="revamp-hiw-kicker">
            <span className="revamp-hiw-dash" aria-hidden="true" />
            <span className="revamp-hiw-kicker-text">Explore</span>
          </div>

          <h2 className="revamp-feed-title">
            Inspiration. Professionals.
            <br />
            Products. <span className="revamp-feed-title-accent">All in one feed.</span>
          </h2>

          <p className="revamp-feed-subtitle">
            Browse by what you need — filter by room, style, budget, or{" "}
            <br className="revamp-feed-subtitle-break" aria-hidden="true" />
            category. Save anything. Post an inquiry in seconds.
          </p>

          <div className="revamp-explore-filters revamp-feed-filters" role="tablist" aria-label="Explore filters">
            {FILTERS.map((label) => (
              <button
                key={label}
                type="button"
                className={label === active ? "active" : ""}
                onClick={() => setActive(label)}
                role="tab"
                aria-selected={label === active}
              >
                {label}
              </button>
            ))}
          </div>
        </div>

        <div className="revamp-feed-body" aria-label="Explore content">
          {visible.pros && (
            <div className="revamp-feed-row" aria-label="Professionals">
              <div className="revamp-feed-row-track">
                <Link to="/enquiry" className="revamp-feed-clickable"><img className="revamp-feed-pro-card-img" src={proCard1} alt="Professional profile card" /></Link>
                <Link to="/enquiry" className="revamp-feed-clickable"><img className="revamp-feed-pro-card-img" src={proCard2} alt="Professional profile card" /></Link>
                <Link to="/enquiry" className="revamp-feed-clickable"><img className="revamp-feed-pro-card-img" src={proCard3} alt="Professional profile card" /></Link>
              </div>
            </div>
          )}

          {visible.ideas && (
            <div className="revamp-feed-row" aria-label="Ideas">
              <div className="revamp-feed-row-track">
                <a className="revamp-feed-clickable" href="https://hynt.co.in/app" target="_blank" rel="noopener noreferrer"><img className="revamp-feed-idea-img" src={idea1} alt="Inspiration" /></a>
                <a className="revamp-feed-clickable" href="https://hynt.co.in/app" target="_blank" rel="noopener noreferrer"><img className="revamp-feed-idea-img" src={idea2} alt="Inspiration" /></a>
                <a className="revamp-feed-clickable" href="https://hynt.co.in/app" target="_blank" rel="noopener noreferrer"><img className="revamp-feed-idea-img" src={idea3} alt="Inspiration" /></a>
                <a className="revamp-feed-clickable" href="https://hynt.co.in/app" target="_blank" rel="noopener noreferrer"><img className="revamp-feed-idea-img" src={idea4} alt="Inspiration" /></a>
                <a className="revamp-feed-clickable" href="https://hynt.co.in/app" target="_blank" rel="noopener noreferrer"><img className="revamp-feed-idea-img" src={idea5} alt="Inspiration" /></a>
              </div>
            </div>
          )}

          {visible.products && (
            <div className="revamp-feed-row" aria-label="Products">
              <div className="revamp-feed-row-track revamp-feed-row-track-products">
                <a className="revamp-feed-clickable" href="https://hynt.co.in/app" target="_blank" rel="noopener noreferrer"><img className="revamp-feed-product-img" src={product1} alt="Product" /></a>
                <a className="revamp-feed-clickable" href="https://hynt.co.in/app" target="_blank" rel="noopener noreferrer"><img className="revamp-feed-product-img" src={product2} alt="Product" /></a>
                <a className="revamp-feed-clickable" href="https://hynt.co.in/app" target="_blank" rel="noopener noreferrer"><img className="revamp-feed-product-img" src={product3} alt="Product" /></a>
                <a className="revamp-feed-clickable" href="https://hynt.co.in/app" target="_blank" rel="noopener noreferrer"><img className="revamp-feed-product-img" src={product4} alt="Product" /></a>
                <a className="revamp-feed-clickable" href="https://hynt.co.in/app" target="_blank" rel="noopener noreferrer"><img className="revamp-feed-product-img" src={product5} alt="Product" /></a>
              </div>
            </div>
          )}
        </div>
      </div>
    </section>
  );
}

export default RevampExploreFeed;

